import { Divider, Link as MuiLink, MenuList, MenuItem, Paper, Typography } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import './ComplianceMenu.css'

const CATALOG_ITEMS = [
  { label: 'GSA', to: '/catalog/gsa/gs-35f-0002v' },
  { label: 'SEWP V', to: '/catalog/sewp/nng15sd41b' },
  { label: 'Seaport NXG', to: '/catalog/seaport' },
  { label: 'GSA OASIS +', to: '/catalog/oasis' },
  { label: 'DLA/Open Market', to: '/catalog/dla' },
  { label: 'ITES-4H', to: '/catalog/ites/w819tc25da023' },
  { label: 'MDA Shield', to: '/catalog/mda' },
  { label: 'NASPO', to: '/catalog/naspo/ar3227' },
  { label: 'ICPT', to: '/catalog/icpt' },
]

const GSA_BPA_ITEMS = [
  { label: '2GIT', to: '/catalog/2git/47qtca21a001g' },
  { label: 'HUD Software BPA', to: '/catalog/gsabpa/86615424f00010' },
  { label: 'USDA Tablet BPA', to: '/catalog/gsabpa/12314425A0003' },
  { label: 'NETS', to: '/catalog/nets' },
  { label: 'DOC NETS BPA', to: '/catalog/gsabpa/1331L525A13OS0016' },
  { label: 'DOL BPA', to: '/catalog/gsabpa/1605TB22A0001' },
  { label: 'HUD HW & UC BPA', to: '/catalog/gsabpa/86615424A00001' },
  { label: 'USDA Laptop BPA', to: '/catalog/gsabpa/12314425A0007' },
  { label: 'LogRhythm ESU/BPA', to: '/catalog/logrhythm' },
  { label: 'GSA - GSS', to: '/catalog/gsabpa/GS-35F-0002V-GSS' },
]

const SEWP_BPA_ITEMS = [
  { label: '(TBD)', to: '/catalog/tbd' }, //placeholder for future items
]

export default function ComplianceMenu(props: { open: boolean; onMouseEnter: () => void; onMouseLeave: () => void }) {
  const location = useLocation()

  if (!props.open) return null

  return (
    <Paper
      className="compliance-menu"
      elevation={3}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      <div className="compliance-menu-section">
        <MuiLink component={RouterLink} to="/catalog/list" className="compliance-menu-label">
          <Typography variant="subtitle2" className="compliance-menu-label">
            Contract List
          </Typography>
        </MuiLink>
      </div>
      <Divider orientation="vertical" flexItem />
      <div className="compliance-menu-groups">
        <MenuList className="compliance-menu-list">
          {CATALOG_ITEMS.map(item => (
            <MenuItem key={item.label} component={RouterLink} to={item.to} selected={location.pathname === item.to}>
              {item.label}
            </MenuItem>
          ))}
        </MenuList>
        <div className="gsa-bpa-menu-list">
          <Divider orientation="horizontal" flexItem />
          <Typography variant="h6" className="compliance-menu-label">
            GSA BPAs
          </Typography>
          <MenuList className="compliance-menu-list">
            {GSA_BPA_ITEMS.map(item => (
              <MenuItem key={item.label} component={RouterLink} to={item.to} selected={location.pathname === item.to}>
                {item.label}
              </MenuItem>
            ))}
          </MenuList>
        </div>
        <div className="sewp-bpa-menu-list">
          <Divider orientation="horizontal" flexItem />
          <Typography variant="h6" className="compliance-menu-label">
            SEWP BPAs
          </Typography>
          <MenuList className="compliance-menu-list">
            {SEWP_BPA_ITEMS.map(item => (
              <MenuItem key={item.label} component={RouterLink} to={item.to} selected={location.pathname === item.to}>
                {item.label}
              </MenuItem>
            ))}
          </MenuList>
        </div>
      </div>
    </Paper>
  )
}
